import React from "react";
import {propertyImportApi} from '../../requests/api';
import SlicedUploadTab, {Stat, noteLine, subjectLine} from './SlicedUploadTab';

/** Lines a test run or an upload lists in its downloadable report: every one of them. */
const REPORT_COLUMNS = ['Row', 'Address', 'Outcome', 'Reason', 'Property ID', 'Changes', 'Notes'];

const API = {
    latest: propertyImportApi.latestUpdating,
    status: propertyImportApi.updatingStatus,
    start: propertyImportApi.startUpdating,
    resume: propertyImportApi.resume,
    rows: propertyImportApi.skippedRows,
    items: propertyImportApi.items,
};

function changesLine(changes) {
    return Object.keys(changes || {})
        .map((column) => `${column}: ${changes[column].from === null ? '—' : changes[column].from} → ${changes[column].to}`)
        .join('; ');
}

const reportRow = (item) => [
    item.external_id,
    subjectLine(item),
    item.outcome,
    item.reason,
    item.property_id,
    changesLine(item.changes),
    (item.notes || []).slice(1).map(noteLine).join(' | '),
];

const stats = (run, notes, dryRun) => (
    <React.Fragment>
        <div className='result-stats'>
            <Stat value={notes.total_rows} label='Total Rows'/>
            <Stat value={run.created} label={dryRun ? 'Would Add' : 'Added'} tone='success'/>
            <Stat value={run.updated} label={dryRun ? 'Would Update' : 'Updated'} tone='success'/>
            <Stat value={run.unchanged} label='Already Up To Date'/>
            <Stat value={run.skipped} label='Skipped' tone='warning'/>
            {run.failed > 0 && <Stat value={run.failed} label='Errors' tone='error'/>}
        </div>

        <div className='result-stats'>
            <Stat value={notes.owners_kept} label='Owner Already On Property'/>
            {notes.owners_returned > 0 && <Stat value={notes.owners_returned} label='Past Owner Back On Property'/>}
            <Stat value={notes.investors_matched} label='Owners Found In Kore'/>
            <Stat value={notes.investors_created} label={dryRun ? 'Owners To Add' : 'Owners Added'} tone='success'/>
            <Stat value={notes.owners_repeated} label='Owner Of An Earlier Row'/>
            <Stat value={notes.owners_replaced} label='Owners Replaced'/>
            <Stat value={notes.owners_not_attached} label='Owners Not Attached' tone='warning'/>
            <Stat value={notes.need_owner} label='Need Owner' tone='warning'/>
        </div>

        <div className='result-stats'>
            <Stat value={notes.notes_added} label='Property Notes'/>
            <Stat value={notes.investor_notes} label='Owner Notes'/>
            <Stat value={notes.beside_protected} label='Added Beside SUMMIT / Closed'/>
            <Stat value={notes.same_as_earlier_line} label='Repeated Rows'/>
            {notes.values_rejected > 0 && <Stat value={notes.values_rejected} label='Values Rejected' tone='error'/>}
        </div>
    </React.Fragment>
);

/**
 * The Database tab: an export of properties with their owners and notes. It
 * edits the property iCLIMB already holds, never a SUMMIT or Closed one, finds
 * each owner in Kore, and has a test run that writes nothing.
 */
const UploadDatabaseTab = () => (
    <SlicedUploadTab
        api={API}
        title='Upload Database'
        instructions={
            <p>A property iCLIMB already holds is updated with the file; a SUMMIT or Closed one is
            left as it is and a new one added beside it. Owners are found in Kore by name, phone
            and company, or added to Kore, and each row&rsquo;s notes go on the property and its owner.</p>
        }
        stats={stats}
        reportColumns={REPORT_COLUMNS}
        reportRow={reportRow}
        canCancel={false}
    />
);

export default UploadDatabaseTab;
